/* import __COLOCATED_TEMPLATE__ from './unselectable-pill.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    text: string;
  };
  Element: HTMLDivElement;
}

const UnselectablePill = templateOnlyComponent<Signature>();
export default UnselectablePill;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::UnselectablePill': typeof UnselectablePill;
    'inbox2/command-k/unselectable-pill': typeof UnselectablePill;
  }
}
